export const data = [
    ['Redes Sociales', 'Instagram'],
    ['Hotel Villegas', 'info@hotelvillegas.es', 'Tel.: 987 75 01 61', 'Palacio, 10. Valencia de don Juan 24200 - León - España']
];
